import React from 'react';

export interface KeyBadgeProps {
  keyValue: string;
}

export const KeyBadge: React.FC<KeyBadgeProps> = ({ keyValue }) => {
  return (
    <code className="px-2 py-1 text-xs bg-gray-100 text-gray-800 rounded">
      {keyValue}
    </code>
  );
};
